export default __webpack_public_path__ + "static/media/front_b.449b61d8.jpg";